module.exports = __webpack_public_path__ + "static/media/iazzu-thumbs-onboarding.cc332634.jpg";